import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';
import isNotEmptyReactElementContent from 'core/utils/content';

/**
 * @author Alexey Rezakov <a.rezakov@rambler-co.ru>
 */
function Incut(props) {
  const {
    children,
    theme: {
      texts: {
        incut,
      },
    },
  } = props;

  if (isNotEmptyReactElementContent(children)) {
    return (
      <div className='incut'>
        <style jsx>{`
          .incut
            font ${incut.font}
            color ${incut.color}
        `}</style>
        {children}
      </div>
    );
  }
  return null;
}

Incut.propTypes = {
  /**
   * Контент вреза
   */
  children: PropTypes.node,
  /** @ignore */
  theme: themePropTypes(`
    {
      texts: {
        quote: {
          font,
          color,
        }
      }
    }
  `),
};

const IncutWithHOCs = withTheme(Incut);
IncutWithHOCs.displayName = 'Incut';

export { Incut as StorybookComponent };
export default IncutWithHOCs;
